module.exports = __webpack_public_path__ + "static/media/security-icon.d7a749a7.svg";